const KEY = "book-video-studio.access-token";

export const getAccessToken = (): string | null => localStorage.getItem(KEY);
export const setAccessToken = (token: string): void => localStorage.setItem(KEY, token);
export const clearAccessToken = (): void => localStorage.removeItem(KEY);
